import React, { useState, useRef, useEffect } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Draggable Scroll
import { useDraggable } from 'react-use-draggable-scroll';

// Material UI
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';

// Helpers
import { returnDateAndTime } from 'helpers/date';

// Components

// Contants
import IMAGES from 'constants/images';
import REPORTS from 'constants/report';

// Actions
import { setClose } from 'store/ducks/dialogs/actions';

// Types
import {
  ScheduleInterface,
  ReportScheduleHistoriesInterface,
} from 'store/ducks/reports/types';
import { ApplicationState } from 'store';

// styles
import useStyles from './TableHistoryDatails.styles';

interface TableHistoryDatailsInterface {
  setReportEntry: (param: ReportScheduleHistoriesInterface | null) => void;
  scheduleData: ReportScheduleHistoriesInterface;
  submissionData: ScheduleInterface;
  reportEntry?: ReportScheduleHistoriesInterface | undefined;
}

const TableHistoryDatails: React.FC<TableHistoryDatailsInterface> = ({
  setReportEntry,
  scheduleData,
  submissionData,
  reportEntry,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const parentRef: any = useRef();
  const { events } = useDraggable(parentRef);

  const current = REPORTS.REPORT_TYPE_COMPONENT.find(
    ({ KEY }) => KEY === submissionData.reportType,
  );
  const CurrentTable = current!.VALUE;
  const CurrentAction = current!.ACTION;

  const [filterUser, setFilterUser] = useState<string[]>([]);
  const [tableReference, setTableReference] = useState(null);
  const [tableCSV, setTableCSV] = useState('');
  const csvRef = useRef();

  const webUsersList = useSelector(
    (state: ApplicationState) => state.users.webUsersList || [],
  );

  const getFilter = (schedule: ReportScheduleHistoriesInterface) => {
    let aux = '';
    Object.keys(schedule.filters).forEach(
      (item: string, i: number) =>
        (aux += `${i ? ', ' : ''}${
          REPORTS.FILTERS_GROUPING.find(({ KEY }) => KEY === item)?.VALUE
        }`),
    );
    return aux;
  };

  const getGroupings = (schedule: ReportScheduleHistoriesInterface) => {
    let aux = '';
    schedule.groupings.forEach(
      (item: string, i: number) =>
        (aux += `${i ? ', ' : ''}${
          REPORTS.FILTERS_GROUPING.find(({ KEY }) => KEY === item)?.VALUE
        }`),
    );
    return aux;
  };

  useEffect(() => {
    const filterName = webUsersList
      .filter(({ id }) =>
        scheduleData.supervisorIds.some((item) => item === id),
      )
      .map(({ name }) => name);
    setFilterUser(filterName);

    if (!reportEntry) {
      document.getElementsByClassName(
        'MuiDialog-paperWidthLg',
        // @ts-ignore
      )[0].style.maxWidth = 'none';
    }
  }, [scheduleData]);

  useEffect(() => {
    if (current?.INCLUDES) {
      dispatch(
        CurrentAction({
          reportType: submissionData.reportType,
          ...scheduleData.filters,
          _group: scheduleData.groupings,
          _includes: current.INCLUDES,
          isHistoryDatails: true,
          segment: true,
        }),
      );
    } else {
      dispatch(
        CurrentAction({
          reportType: submissionData.reportType,
          ...scheduleData.filters,
          _group: scheduleData.groupings,
          isHistoryDatails: true,
          segment: true,
        }),
      );
    }
  }, []);

  return (
    <Grid item className={!reportEntry ? classes.content : ''}>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='flex-end'
        margin='24px'
        marginRight='16px'>
        <IconButton>
          <img src={IMAGES.REPORTS_ICONS.DOWNLOAD} alt='download' />
        </IconButton>
        <IconButton>
          <img src={IMAGES.REPORTS_ICONS.SEND_MENSSAGE} alt='send' />
        </IconButton>
        <IconButton
          onClick={() => {
            setReportEntry(null);
            dispatch(setClose({}));
          }}>
          <img src={IMAGES.ICONS.CLOSE} alt='close' />
        </IconButton>
      </Box>
      <Box display='grid' margin='24px 24px 8px 24px'>
        <Typography variant='h4'>{scheduleData?.title}</Typography>
        <Typography className={classes.contentDate}>
          {' '}
          {returnDateAndTime(scheduleData?.createdAt)}{' '}
        </Typography>
        <Divider variant='fullWidth' />
        <Typography className={classes.title}>Enviado para:</Typography>
        <Grid
          className={classes.contentArrayRecipient}
          {...events}
          ref={parentRef}>
          {filterUser.length < 6 && (
            <Box display='flex' alignItems='center' marginBottom='8px'>
              {filterUser.map((item: string, i: number) => {
                return (
                  <Box className={classes.contentRecipient}>
                    <Box className={classes.contentImage}> </Box>
                    <Typography className={classes.recipient}>
                      {item}
                    </Typography>{' '}
                    <Box style={{ margin: '0px 8px' }} />
                  </Box>
                );
              })}
            </Box>
          )}

          {filterUser.length > 5 && (
            <>
              <Box display='flex' alignItems='center'>
                {filterUser.map((item: string, i: number) => {
                  if (i % 2 === 0) {
                    return (
                      <Box className={classes.contentRecipient}>
                        <Box className={classes.contentImage}> </Box>
                        <Typography className={classes.recipient}>
                          {item}
                        </Typography>{' '}
                        <Box style={{ margin: '0px 8px' }} />
                      </Box>
                    );
                  }
                })}
              </Box>
              <Box display='flex' alignItems='center'>
                {filterUser.map((item: string, i: number) => {
                  if (i % 2 !== 0) {
                    return (
                      <Box className={classes.contentRecipient}>
                        <Box className={classes.contentImage}> </Box>
                        <Typography className={classes.recipient}>
                          {item}
                        </Typography>{' '}
                        <Box style={{ margin: '0px 8px' }} />
                      </Box>
                    );
                  }
                })}
              </Box>
            </>
          )}
        </Grid>
        <Divider variant='fullWidth' />
        <Typography className={classes.title}>
          Filtros e Agrupamentos
        </Typography>
      </Box>
      {Boolean(Object.values(scheduleData?.filters).length) && (
        <Box display='flex' paddingLeft='24px' marginBottom='16px'>
          <Box className={classes.contentFilters}>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='space-between'>
              <Box paddingRight='16px'>
                <img src={IMAGES.REPORTS_ICONS.FILTERS_BLACK} alt='filters' />
              </Box>
              <Typography>Filtros -</Typography>{' '}
            </Box>{' '}
            <Box paddingLeft='8px'>{getFilter(scheduleData)}</Box>
          </Box>
        </Box>
      )}
      {Boolean(Object.values(scheduleData?.groupings).length) && (
        <Box display='flex' paddingLeft='24px'>
          <Box className={classes.contentFilters}>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='space-between'>
              <Box paddingRight='16px'>
                <img
                  src={IMAGES.REPORTS_ICONS.AGRUPMENTS_BLACK}
                  alt='groupings'
                />
              </Box>
              <Typography>Agrupamentos -</Typography>{' '}
            </Box>{' '}
            <Box paddingLeft='8px'>{getGroupings(scheduleData)}</Box>
          </Box>
        </Box>
      )}
      <Box margin='24px'></Box>
      <Grid
        ref={(node: any) => {
          setTableReference(node);
        }}>
        <CurrentTable
          isHistoryDatails={true}
          setTableReference={setTableReference}
          setTableCSV={setTableCSV}
          groupings={submissionData.groupings}
          tableReference={tableReference}
          csvRef={csvRef}
        />
      </Grid>
    </Grid>
  );
};

export { TableHistoryDatails };
export default TableHistoryDatails;
